<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span v-if="!loading" slot="left-title">
        <span v-if="parent">Création d'une Sous-Origine</span>
        <span v-else>Création d'une Origine</span>
      </span>
    </sticky>
    <spinner-round v-if="loading" :isLoading="loading"></spinner-round>
    <div class="columns is-gapless is-padding-left-on-btn-actions is-padding-right-on-btn-actions is-padding-top" v-else>
      <div class="column is-12 is-8-widescreen is-7-fullhd">
        <div class="has-bg-white is-border">
          <origin-form @failed="submitFailed" :parent='parent' @submit="submit" :loading="loading"></origin-form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import OriginForm from '@/components/origin/OriginForm'

  export default {
    name: 'OriginCreate',
    components: {
      OriginForm
    },
    data () {
      return {
        parent: null,
        loading: false
      }
    },
    computed: {},
    methods: {
      getParentOrigin (parentPk) {
        this.loading = true
        this.$api.originService.getOne(parentPk)
          .then(res => {
            this.parent = res.data
            this.loading = false
          })
          .catch((err) => {
            console.log(err)
            this.loading = false
          })
      },
      submitFailed (origin) {
        console.log('error with origin > ', origin)
      },
      submit (origin) {
        if (this.$route.query.parent) {
          origin.parent = this.$route.query.parent
        }
        this.loading = true
        this.$api.originService.post(origin)
          .then(res => {
            this.loading = false
            this.$notify({
              type: 'is-success',
              text: 'Origine ajoutée.'
            })
            if (res.data.parent) {
              this.$router.push({name: 'OriginVue', params: {id: res.data.parent}})
            } else {
              this.$router.push({name: 'OriginVue', params: {id: res.data.pk}})
            }
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            this.$notify({
              type: 'is-danger',
              text: 'Erreur lors de l\'enregistrement.'
            })
          })
      }
    },
    created () {
      if (this.$route.query.parent) {
        this.getParentOrigin(this.$route.query.parent)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/origin/OriginCreate.vue